module.exports = __webpack_public_path__ + "img/2026big2.749391f3.png";